import useFreePlanStatus from '../../hooks/useFreePlanStatus';
import './FreeUpgradeAlert.css';

/**
 * Alerta especial para página de planos
 * Destaca urgência de upgrade para usuários FREE próximos de expirar
 */
export default function FreeUpgradeAlert() {
  const freeStatus = useFreePlanStatus();
  
  // Não exibe se não é FREE ou se não está próximo de expirar
  if (!freeStatus.isFreePlan || (!freeStatus.shouldShowWarning && !freeStatus.isExpired)) {
    return null;
  }
  
  // Formatar data de expiração
  const formatDate = (isoDate) => {
    if (!isoDate) return '';
    return new Date(isoDate).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  };
  
  // Determinar conteúdo baseado no status
  const getContent = () => {
    if (freeStatus.isExpired) {
      return {
        icon: '🔴',
        title: 'Seu período gratuito expirou',
        message: `Seu acesso expirou${freeStatus.expirationDate ? ` em ${formatDate(freeStatus.expirationDate)}` : ''}. Escolha um plano abaixo para continuar aproveitando todas as funcionalidades do Easyvog Plus sem interrupções.`,
        className: 'free-upgrade-alert-expired'
      };
    }
    
    if (freeStatus.urgencyLevel === 'danger') {
      return {
        icon: '⚠️',
        title: freeStatus.daysRemaining === 1 ? 'Último dia de acesso gratuito!' : 'Seu acesso expira hoje!',
        message: `Não perca o acesso! Escolha um plano agora para continuar usando todas as funcionalidades sem interrupção.`,
        className: 'free-upgrade-alert-danger'
      };
    }
    
    if (freeStatus.urgencyLevel === 'warning') {
      return {
        icon: '⏰',
        title: `Seu período gratuito expira em ${freeStatus.daysRemaining} dias`,
        message: `Garanta seu acesso contínuo! Escolha um plano abaixo e continue aproveitando todas as vantagens do Easyvog Plus.`,
        className: 'free-upgrade-alert-warning'
      };
    }
    
    return {
      icon: '📅',
      title: `Seu período gratuito expira em ${freeStatus.daysRemaining} dias`,
      message: `Aproveite esta oportunidade para garantir acesso contínuo. Escolha um plano e continue aproveitando todas as funcionalidades sem interrupções.`,
      className: 'free-upgrade-alert-info'
    };
  };
  
  const content = getContent();
  
  return (
    <div className={`free-upgrade-alert ${content.className}`}>
      <div className="free-upgrade-alert-content">
        <div className="free-upgrade-alert-icon">{content.icon}</div>
        <div className="free-upgrade-alert-text">
          <h2 className="free-upgrade-alert-title">{content.title}</h2>
          <p className="free-upgrade-alert-message">{content.message}</p>
        </div>
      </div>
      {freeStatus.expirationDate && !freeStatus.isExpired && (
        <div className="free-upgrade-alert-footer">
          <span className="free-upgrade-alert-expiration">
            Expira em: <strong>{formatDate(freeStatus.expirationDate)}</strong>
          </span>
        </div>
      )}
    </div>
  );
}
